//import { AssistantAction } from './assistant-actions';
import {
  IAssistantTask,
  IAssistantAction,
  IAssistantTrigger,
  IElementSelectorDefinition,
} from '../../types/assistant';

import { waitForValueToStopChanging } from './assitant-wait-for-value';
import * as _ from 'lodash';
import * as style from './assistant-utils.scss';
//import { tpaConfigs, TpaTypes, StoryServices } from '@wix/adi-core-santa-layer';
//import { events, PubSub } from '../pub-sub';
//import { flags } from '../../config/app-flags';

//%%remove!!!
//const assistantManager = new AssistantManager(null);
class AssistantUtils {
  // implements IAssistantUtils {
  public DEFAULT_TRIGGER: string = 'click';
  DELAY_BEFORE_SPINNER_WAIT: number = 800;
  TOUR_STEP_TOOLTIP_COMPONENT: string =
    '<assistant-tooltip action="action"></assistant-tooltip>';
  STORAGE_KEY: string = 'ob_tasks';
  OLD_STORAGE_KEY: string = 'ob_tours';
  ELEMENT_SELECTOR = '$element';
  callbacks = {};
  elementsToRevertPosition = new Set<HTMLElement>();

  // private readonly tourToAssistantNameDictionary = {
  //   previewTour: 'previewTask',
  //   entireWebsiteDesign: 'entireWebsiteDesignTask',
  //   editContentTour: 'editContentTask',
  //   customizeSectionDesign: 'customizeSectionDesign',
  //   pageSEOTour: 'pageSEOTask',
  //   changeLayoutTour: 'changeLayoutTour',
  //   addSectionTour: 'addSectionTask',
  //   welcomeTour: 'welcomeTask',
  //   addNewPageTour: 'addNewPageTask',
  //   animationTour: 'animationTask',
  // };

  constructor() // private readonly $window: ng.IWindowService, // private readonly $timeout: ng.ITimeoutService, // private readonly $state, // private readonly $q: ng.IQService,
  // private readonly $compile: ng.ICompileService,
  // private readonly $rootScope: ng.IRootScopeService,
  // private readonly spinnerService,
  // private readonly ELEMENT_SELECTOR: string,
  // private readonly storyServices: StoryServices,
  // private readonly applicationParameters: any,
  // private readonly $injector,
  {}

  public compileTemplateContent(
    _assistantManager,
    task: IAssistantTask,
    action: IAssistantAction,
  ): any {
    return null;
  }

  public redirectToState(state: string): any {
    return null;
  }

  public triggerElement(elementSelector: string, triggerType: string): void {}

  private addOverlayElement(originalElement: HTMLElement) {
    const overlayElement = document.createElement('overlayElement');
    overlayElement.classList.add(style.OverlayElement);
    if (window.getComputedStyle(originalElement).position === 'static') {
      this.elementsToRevertPosition.add(originalElement);
      originalElement.style.position = 'relative';
    }
    originalElement.appendChild(overlayElement);
    return overlayElement;
  }

  private removeOverlayElement(
    originalElement: HTMLElement,
    overlayElement: HTMLElement
  ) {
    if (this.elementsToRevertPosition.has(originalElement)) {
      originalElement.style.position = 'static';
      this.elementsToRevertPosition.delete(originalElement);
    }
    overlayElement.remove();
  }

  public registerActionTrigger(
    actionTrigger: IAssistantTrigger,
    cb: Function,
  ): void {
    const callback = async (event) => {
      if (actionTrigger.callback) {
        await actionTrigger.callback();
      }
      if (actionTrigger.ignoreOriginalEvent) {
        event.stopPropagation();
      }
      cb(actionTrigger.intent);
    };

    const selector = `${actionTrigger.element} ${
      actionTrigger.descendant || ''
    }`;
    const key = `${selector}_${actionTrigger.trigger}`;
    this.callbacks[key] = callback;
    document.querySelectorAll<HTMLElement>(selector).forEach((element) => {
      let targetElement: HTMLElement = element;
      if (actionTrigger.ignoreOriginalEvent) {
        actionTrigger.overlayElement = this.addOverlayElement(element);
        targetElement = actionTrigger.overlayElement;
      }
      targetElement.addEventListener(actionTrigger.trigger, callback, {
        once: true,
      });
    });
  }

  //public unregisterActionTrigger(actionTrigger: IAssistantTrigger): void {}
  public unregisterActionTrigger(actionTrigger: IAssistantTrigger): void {
    const selector = `${actionTrigger.element} ${
      actionTrigger.descendant || ''
    }`;
    const key = `${selector}_${actionTrigger.trigger}`;
    document.querySelectorAll<HTMLElement>(selector).forEach((element) => {
      if (actionTrigger.ignoreOriginalEvent) {
        actionTrigger.overlayElement.removeEventListener(
          actionTrigger.trigger,
          this.callbacks[key]
        );
        this.removeOverlayElement(element, actionTrigger.overlayElement);
      } else {
        element.removeEventListener(actionTrigger.trigger, this.callbacks[key]);
      }
    });
    delete this.callbacks[key];
  }

  public replaceElementSelectorPlaceholderWithValue(
    elementSelector: string,
    valueToReplace: string,
  ): string {
    return elementSelector
      ? elementSelector.replace(this.ELEMENT_SELECTOR, valueToReplace)
      : valueToReplace;
  }

  public waitForSpinner(shouldWait: boolean): Promise<any> {
    return Promise.resolve();
  }

  public shouldWaitForElementToStopMoving(action: IAssistantAction): boolean {
    return !!action?.element?.waitForElementToStopMoving;
  }

  public waitForElementToStopMoving(action: IAssistantAction): Promise<any> {
    const selector = action?.element?.selector;
    const element = document.querySelector(selector);
    return waitForValueToStopChanging(async () => {
      const boundingRect = element?.getBoundingClientRect();
      if (typeof boundingRect !== 'undefined') {
        const { top, right, bottom, left, width, height, x, y } = boundingRect;
        return { top, right, bottom, left, width, height, x, y };
      }
    });
  }

  public delayAction(delayInMs: number = 0): Promise<any> {
    return new Promise((res) => setTimeout(res, delayInMs));
  }

  public getHTMLElement(element: IElementSelectorDefinition) {
    if (!element.isRandom) {
      return document.querySelector<HTMLElement>(element.selector);
    }

    return this.getRandomHTMLElement(element);
  }

  private getRandomHTMLElement(element: IElementSelectorDefinition): Element {
    if (
      !(element as any).randomElementsBank ||
      !(element as any).randomElementsBank.length
    ) {
      (element as any).randomElementsBank = this.createArrayAccordingToNumberOfElementsOnScreen(
        element.selector,
      );
    }
    const randomElementIndex = this.getAndRemoveRandomElementFromArray(
      (element as any).randomElementsBank,
    );
    return document.querySelectorAll<HTMLElement>(element.selector)[
      randomElementIndex
    ];
  }

  private createArrayAccordingToNumberOfElementsOnScreen(
    elementSelector: string,
  ): number[] {
    return _.range(
      0,
      document.querySelectorAll<HTMLElement>(elementSelector).length,
    );
  }

  private getAndRemoveRandomElementFromArray(array: any[]): any {
    return array.splice(Math.floor(Math.random() * array.length), 1)[0];
  }

  public getDefaultExitTrigger(
    exitTriggers: IAssistantTrigger[] = [],
  ): IAssistantTrigger {
    return _.find(exitTriggers, { isDefault: true }) || exitTriggers[0];
  }

  public broadcastAssistantEvent(event: string, ...args): void {}
}

export default new AssistantUtils();
